import { gql } from 'apollo-boost';

export const getBranchs = gql`
    query{
        branchs{
            _id,
            name
        }
    }
`;

export const getBranchsByUser = gql`
    query GetBranchsByUser(
        $user: ID!,
    ){
        branchsByUser(
            user: $user
        ){
            _id,
            name
        }
    }
`;

export const getBranch = gql`
    query getBranch(
        $_id: ID!,
    ){
        branch(
            _id: $_id
        ){
            _id,
            name
        }
    }
`;


// WEBPACK FOOTER //
// ./src/graphql/query/branch.js